export enum DirectionKindEnum {
  OPERATING_INCOME = 'OPERATING_INCOME',
  OTHER_INCOME = 'OTHER_INCOME',
  OPERATING_EXPENSE = 'OPERATING_EXPENSE',
  COMMERCIAL_EXPENSE = 'COMMERCIAL_EXPENSE',
  OTHER_EXPENSE = 'OTHER_EXPENSE',
  FINANCIAL_ACTIVITY = 'FINANCIAL_ACTIVITY',
  TECHNICAL_OPERATIONS = 'TECHNICAL_OPERATIONS',
}
